// Dutch voice narration using the Web Speech API, tuned to sound as
// natural (human) as possible with the free browser voices available.
let enabled = true;
let dutchVoice = null;

// Rank voices so we prefer higher-quality (usually network/cloud) Dutch voices.
function scoreVoice(v) {
  const name = (v.name || "").toLowerCase();
  const lang = (v.lang || "").toLowerCase();
  let score = 0;
  if (lang.startsWith("nl")) score += 100;
  else if (/dutch|nederlands|netherlands/.test(name)) score += 60;
  else return -1; // not Dutch at all
  // Cloud / network voices are far more natural than the built-in robotic ones.
  if (v.localService === false) score += 40;
  // Known good, more human-sounding engines.
  if (name.includes("google")) score += 35;
  if (name.includes("natural")) score += 30;   // MS "Natural" neural voices
  if (name.includes("microsoft")) score += 15;
  if (name.includes("premium") || name.includes("enhanced")) score += 20;
  // Prefer a warm female voice (Colette/Fenna/Lotte are common nl voices).
  if (/colette|fenna|lotte|femke|saskia|female|vrouw/.test(name)) score += 8;
  if (lang === "nl-nl") score += 5;
  return score;
}

function pickVoice() {
  if (!("speechSynthesis" in window)) return;
  const voices = window.speechSynthesis.getVoices();
  if (!voices || !voices.length) return;
  let best = null;
  let bestScore = 0;
  for (const v of voices) {
    const s = scoreVoice(v);
    if (s > bestScore) { bestScore = s; best = v; }
  }
  if (best) dutchVoice = best;
}

if ("speechSynthesis" in window) {
  pickVoice();
  window.speechSynthesis.onvoiceschanged = pickVoice;
}

export function setVoiceEnabled(v) {
  enabled = v;
  if (!v && "speechSynthesis" in window) window.speechSynthesis.cancel();
}

// A little humanising: add gentle natural pauses so it doesn't rush like a robot.
function humanize(text) {
  return String(text)
    .replace(/!+/g, "! ")
    .replace(/\?+/g, "? ")
    .replace(/\s+/g, " ")
    .trim();
}

export function speak(text, { rate = 0.92, pitch = 1.0, interrupt = true } = {}) {
  if (!enabled || !text || !("speechSynthesis" in window)) return;
  try {
    if (interrupt) window.speechSynthesis.cancel();
    if (!dutchVoice) pickVoice();
    const u = new SpeechSynthesisUtterance(humanize(text));
    u.lang = dutchVoice?.lang || "nl-NL";
    if (dutchVoice) u.voice = dutchVoice;
    // Slightly slower + near-natural pitch reads far more human than the
    // default fast/high robotic settings.
    u.rate = rate;
    u.pitch = pitch;
    u.volume = 1;
    window.speechSynthesis.speak(u);
  } catch (e) {
    /* noop */
  }
}

export function stopSpeaking() {
  if ("speechSynthesis" in window) window.speechSynthesis.cancel();
}
